var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgZnak(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1576128901571183078 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.23455 8.23437V3.39062C8.23455 2.85781 8.67049 2.42188 9.2033 2.42188C9.73612 2.42188 10.1721 2.85781 10.1721 3.39062V9.6875L11.6252 7.16875C11.9158 6.68437 12.4971 6.53906 12.9814 6.87812C13.3205 7.12031 13.5142 7.55625 13.3205 7.99219C12.5455 10.075 11.383 12.0609 9.92987 13.7562",
    stroke: "white",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.23438 8.23438V2.42188C8.23438 1.88906 7.79844 1.45312 7.26562 1.45312C6.73281 1.45312 6.29688 1.88906 6.29688 2.42188V8.23438",
    stroke: "white",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.29688 8.23438V3.39062C6.29688 2.85781 5.86094 2.42188 5.32812 2.42188C4.79531 2.42188 4.35938 2.85781 4.35938 3.39062V8.23438",
    stroke: "white",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M4.35938 8.23438V4.35938C4.35938 3.82656 3.92344 3.39062 3.39062 3.39062C2.85781 3.39062 2.42188 3.82656 2.42188 4.35938V8.23438C2.42188 10.1719 2.80937 12.0609 3.58437 13.8047",
    stroke: "white",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZnak);
export default __webpack_public_path__ + "static/media/znak.b90305009e7e2a5a7c08bbc279f0e48c.svg";
export { ForwardRef as ReactComponent };